import { Text } from '@doda/io-react/common';
import { TextWithLF } from '@doda/common/src/components/ReferredJobDetail/TextWithLF';
import styles from './index.module.scss';

/**
 * InterviewReportのProps
 */
export interface Props {
  reportRewarding?: string;
  reportDifficult?: string;
}

const REWARDING_WORD = 'やりがい';
const DIFFICULT_WORD = 'きびしさ';

const IMG_REWAEDING_URL =
  'https://doda.jp/DodaFront/Html/images/icon_kyujin_rewarding.png';
const IMG_DIFFICULT_URL =
  'https://doda.jp/DodaFront/Html/images/icon_kyujin_strict.png';

/**
 * 取材レポート
 */
export const InterviewReportItem: React.FC<Props> = ({
  reportRewarding,
  reportDifficult,
}: Props) => {
  if (!reportRewarding && !reportDifficult) {
    return null;
  }

  return (
    <div
      className={
        styles['jobSearchDetail-interviewReport__contentsInterviewItem']
      }
    >
      <div
        className={
          styles[
            'jobSearchDetail-interviewReport__contentsInterviewItemIconWrap'
          ]
        }
      >
        <img
          src={reportRewarding ? IMG_REWAEDING_URL : IMG_DIFFICULT_URL}
          alt={reportRewarding ? REWARDING_WORD : DIFFICULT_WORD}
          className={
            styles['jobSearchDetail-interviewReport__contentsInterviewItemIcon']
          }
        />
        <Text color="gray" size="11" weight="bold">
          {reportRewarding ? REWARDING_WORD : DIFFICULT_WORD}
        </Text>
      </div>
      <Text color="black_pc" size="14--articlePC">
        <TextWithLF text={reportRewarding || reportDifficult || ''} />
      </Text>
    </div>
  );
};
